import React from 'react';
import PropTypes from 'prop-types';

const POICuisine = (props) => {
  const cuisines = props._source.cuisines;

  return (
    <div className="sk-hits-list-hit__cuisines">
     {cuisines.slice(0, 2).map((cuisine, i) => (
        <div key={i}>{cuisine}</div>
      ))}
    </div>
  )
};

POICuisine.propTypes = {
  _source: PropTypes.shape({
    cuisines: PropTypes.array
  })
};

export default POICuisine;



// WEBPACK FOOTER //
// ./app/webpack/packs/javascripts/searchBox/POIListItems/POICuisine.jsx